import React, { useState, useEffect } from "react";
import "./HappyFeedback.css"
import { motion, AnimatePresence, delay } from "motion/react"
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { duration } from "@mui/material";
import CustomSpinner from "../../components/CustomSpinner";


import rating1 from "../../images/emojis/rate1.png"
import rating2 from "../../images/emojis/rate2.png"
import rating3 from "../../images/emojis/rate3.png"
import rating4 from "../../images/emojis/rate4.png"
import rating5 from "../../images/emojis/rate5.png"


function HappyFeedback({ serverURL }) {

    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({ "overall_rating": 5, "most_helpfull_services": [] });
    const [submitted, setSubmitted] = useState(false);
    const [message, setMessage] = useState(null)
    const [vallidity, setVallidity] = useState(false)
    const [loading, setLoading] = useState(true)
    const [showOtherDiscontinueReasones, setShowOtherDiscontinueReasones] = useState(false)
    const [showOtherStageDiscontinue, setShowOtherStageDiscontinue] = useState(false)

    const [ratingValue, setRatingValue] = useState(5)
    const stepsLength = 9; // Total steps


    const validateOptions = (step) => {

        const stepNames = [
            { "type": "overall_experience", "required": true },
            { "type": "most_helpfull_services", "required": true },
            { "type": "why_chose_yesgermany", "required": true },
            { "type": "overall_rating", "required": false },
            { "type": "service_rating", "required": true },
            { "type": "most_liked_things", "required": false },
            { "type": "improvements", "required": false },
            { "type": "recommend", "required": true },
            { "type": "video-and-testomonials", "required": false },
        ]

        // const stepNames = [
        //     { "type": "old_discontinue_stage", "required": true },
        //     { "type": "old_discontinue_reasons", "required": true },
        //     { "type": "old_service_rating", "required": true },
        //     { "type": "old_specific_issue", "required": false },
        //     { "type": "old_clarity", "required": true },
        //     { "type": "old_understanding", "required": true },
        //     { "type": "old_improvements", "required": false },
        //     { "type": "old_plan_to_study", "required": true },
        //     { "type": "old_recommend", "required": true },
        //     { "type": "old_final_comments", "required": false },
        //     { "type": "old_overall_rating", "required": true },
        // ]


        if (stepNames[step].required) {
            if (formData[stepNames[step].type]) {
                if (typeof formData[stepNames[step].type] === 'object' && !Array.isArray(formData[stepNames[step].type])) {
                    console.log(formData[stepNames[step].type])
                    if (formData[stepNames[step].type].other.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else if (Array.isArray(formData[stepNames[step].type])) {
                    if (formData[stepNames[step].type].length == 1) {
                        if (JSON.stringify(formData[stepNames[step].type]).includes("other")) {
                            if (formData[stepNames[step].type][0].other) {
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return true
                        }
                    }
                    else if (formData[stepNames[step].type].length > 1) {
                        return true
                    }
                    else {
                        return false
                    }
                } else {
                    if (formData[stepNames[step].type].length > 0) {
                        return true
                    } else {
                        return false
                    }
                }
            } else {
                return false
            }
        } else {
            return true
        }

    }

    const handleNext = () => {
        if (!validateOptions(currentStep)) {
            setMessage("Please complete this step")
        } else {
            if (currentStep < stepsLength - 1) {
                setCurrentStep(currentStep + 1);
                setMessage(null)
            } else {
                console.log("handle invalid")
            }
        }

    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitted(true)
        console.log(formData)

        let totalId = window.location.href.split("survey/")[1]

        const query = {
            "stdid": totalId,
            "email": totalId.split("-")[0],
            "stdcode": totalId.split("-")[0],
            "formData": formData,
            "responseType":"survey"
        }

        console.log(totalId)
        const submitFeedback = await axios.post(serverURL + "/survey/saveSurvey", query)
        if (submitFeedback.status === 200) {
            console.log(submitFeedback.data)
        } else {
            console.log(submitFeedback.data)
        }
    }

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const updateSlider = (e) => {
        setRatingValue(e)
        console.log(e)
    }

    useEffect(() => {
        console.log(currentStep)
    }, [currentStep])

    const handleInput = (name, value, isMulti) => {
        let multiValues = []
        if (isMulti) {
            const elems = document.getElementsByClassName(name)


            for (let i = 0; i < elems.length; i++) {
                if (elems[i].checked) {
                    multiValues.push(elems[i].value)
                } else if (elems[i].type === "text") {
                    multiValues.push({ "other": elems[i].value })
                } else {

                }
            }
            let allData = formData
            allData[name] = multiValues
            setFormData(allData)
        } else {
            let allData = formData
            allData[name] = value
            setFormData(allData)
            // console.log(allData)
        }
    }

    const validify = async (totalId) => {
        console.log(totalId)
        const checkValidity = await axios.post(serverURL + "/survey/checkSurvey", { "stdid": totalId })
        if (checkValidity.status === 200) {
            setVallidity(true)
            setLoading(false)
        } else {
            setVallidity(false)
            setLoading(false)
        }
    }

    useEffect(() => {
        let totalId = window.location.href.split("survey/")[1]
        setLoading(true)
        validify(totalId)
    }, [])

    return (
        <div className="mainContainer vh-100 vw-100 display-flex align-items-center p-4">
            <AnimatePresence>
                {
                    loading ?
                        <motion.div
                            initial={{ opacity: 0, }}
                            animate={{ opacity: 1, }}
                            exit={{ opacity: 0, }}
                            transition={{ duration: 0.3, delay: 0 }}
                        >
                            <CustomSpinner size={1} />
                        </motion.div>
                        :
                        vallidity ?
                            <motion.div
                                initial={{ opacity: 0, translateY: "-20px" }}
                                animate={{ opacity: 1, translateY: "0px" }}
                                exit={{ opacity: 0, translateY: "-20px" }}
                                transition={{ durataion: 0.3, delay: 1 }}
                                className="w-100 feedbackForm" style={{ maxWidth: "900px" }} >
                                {
                                    !submitted ?
                                        <form>
                                            <div className="header d-flex flex-wrap justify-content-around">
                                                <div className="logo">
                                                    <img
                                                        src="https://yesgermany.org/ygLogoMailSignature.png"
                                                        alt="YES Germany Logo"
                                                    />
                                                </div>
                                                <h1>Student's Survey</h1>
                                            </div>

                                            <div className="progress-container">
                                                <div
                                                    className="progress-bar"
                                                    style={{ width: `${(currentStep / (stepsLength - 1)) * 100}%` }}
                                                ></div>
                                            </div>

                                            <div className="step active">
                                                <>
                                                    {
                                                        currentStep === 0 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Overall experience with YES Germany?</label>
                                                            <select name="overall_experience" className="overall_experience" defaultValue={formData.overall_experience || ""} onChange={(e) => { handleInput("overall_experience", e.target.value, false) }} required>
                                                                <option value="" disabled defaultChecked>-- Select an option --</option>
                                                                {["Very Satisfied", "Satisfied", "Neutral", "Dissatisfied", "Very Dissatisfied"].map((option) => (
                                                                    <option key={option}>{option}</option>
                                                                ))}
                                                            </select>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 1 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Most helpful services (Select all that apply):</label>
                                                            <div className="checkbox-group">
                                                                {[

                                                                    "University Selection & Admission Guidance",
                                                                    "SOP/LOR/Document Support",
                                                                    "German Language Training",
                                                                    "Visa Application Assistance",
                                                                    "Accommodation Support",
                                                                    "Pre-Departure Briefing",
                                                                    "Post-Arrival Services in Germany",].map((reason) => (
                                                                        <label key={reason}>
                                                                            <input
                                                                                type="checkbox"
                                                                                name="most_helpfull_services"
                                                                                value={reason}
                                                                                className="most_helpfull_services"
                                                                                defaultChecked={formData["most_helpfull_services"].filter((res) => { return JSON.stringify(res).includes(reason) }).length > 0}
                                                                                onChange={(e) => { handleInput("most_helpfull_services", reason, true) }}
                                                                            />
                                                                            {reason}
                                                                        </label>
                                                                    ))}
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        name="most_helpfull_services"
                                                                        value="Other"
                                                                        defaultChecked={formData["most_helpfull_services"]?.filter((res) => { return JSON.stringify(res).includes("other") }).length > 0}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                setShowOtherDiscontinueReasones(true)
                                                                            } else {
                                                                                setShowOtherDiscontinueReasones(false);
                                                                                handleInput("most_helpfull_services", '', true)
                                                                            }
                                                                        }}
                                                                    />
                                                                    Other
                                                                </label>
                                                                {showOtherDiscontinueReasones && (
                                                                    <input
                                                                        type="text"
                                                                        name="discontinue_reasons_other"
                                                                        placeholder="Please specify"
                                                                        className="most_helpfull_services"
                                                                        defaultValue={
                                                                            formData["most_helpfull_services"]?.filter((res) => { return JSON.stringify(res).includes("other") }).length > 0 ?
                                                                                formData["most_helpfull_services"].filter((res) => { return JSON.stringify(res).includes("other") })[0].other
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(e) => { handleInput("most_helpfull_services", e.target.value, true) }}
                                                                    />
                                                                )}
                                                            </div>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 2 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Why did you choose YES Germany?</label>
                                                            <div className="checkbox-group">
                                                                {["University Selection & Admission Guidance",
                                                                    "Reputation",
                                                                    "Transparency",
                                                                    "Personalized Support",
                                                                    "Affordable Fees",
                                                                    "Strong Germany Network",
                                                                ].map((reason) => (
                                                                    <label key={reason}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="why_chose_yesgermany"
                                                                            value={reason}
                                                                            className="why_chose_yesgermany"
                                                                            defaultChecked={formData["why_chose_yesgermany"]?.filter((res) => { return JSON.stringify(res).includes(reason) }).length > 0}
                                                                            onChange={(e) => { handleInput("why_chose_yesgermany", reason, true) }}
                                                                        />
                                                                        {reason}
                                                                    </label>
                                                                ))}
                                                                <label>
                                                                    <input
                                                                        type="checkbox"
                                                                        name="why_chose_yesgermany"
                                                                        value="Other"
                                                                        defaultChecked={formData["why_chose_yesgermany"]?.filter((res) => { return JSON.stringify(res).includes("other") }).length > 0}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                setShowOtherDiscontinueReasones(true)
                                                                            } else {
                                                                                setShowOtherDiscontinueReasones(false);
                                                                                handleInput("why_chose_yesgermany", '', true)
                                                                            }
                                                                        }}
                                                                    />
                                                                    Other
                                                                </label>
                                                                {showOtherDiscontinueReasones && (
                                                                    <input
                                                                        type="text"
                                                                        name="discontinue_reasons_other"
                                                                        placeholder="Please specify"
                                                                        className="why_chose_yesgermany"
                                                                        defaultValue={
                                                                            formData["why_chose_yesgermany"]?.filter((res) => { return JSON.stringify(res).includes("other") }).length > 0 ?
                                                                                formData["why_chose_yesgermany"].filter((res) => { return JSON.stringify(res).includes("other") })[0].other
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(e) => { handleInput("why_chose_yesgermany", e.target.value, true) }}
                                                                    />
                                                                )}
                                                            </div>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 3 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="w-100 text-center d-flex flex-column gap-5">
                                                                <span className="questionHeader">Rate YES Germany's team responsiveness:</span>
                                                                <span style={{ fontSize: "50px" }} className="w-100 d-flex justify-content-center align-items-center">
                                                                    {
                                                                        parseInt(formData["overall_rating"]) === 1 ?
                                                                            <img className="emojisFeedback" src={rating1} />
                                                                            :
                                                                            parseInt(formData["overall_rating"]) === 2 ?
                                                                                <img className="emojisFeedback" src={rating2} />
                                                                                :
                                                                                parseInt(formData["overall_rating"]) === 3 ?
                                                                                    <img className="emojisFeedback" src={rating3} />
                                                                                    :
                                                                                    parseInt(formData["overall_rating"]) === 4 ?
                                                                                        <img className="emojisFeedback" src={rating4} />
                                                                                        :
                                                                                        parseInt(formData["overall_rating"]) === 5 ?
                                                                                            <img className="emojisFeedback" src={rating5} />
                                                                                            :
                                                                                            <img className="emojisFeedback" src={rating5} />

                                                                    }
                                                                </span>
                                                                <div className="slider-group w-100 m-0">
                                                                    <input
                                                                        type="range"
                                                                        name="overall_rating"
                                                                        min="1"
                                                                        max="5"
                                                                        className="overall_rating w-100"
                                                                        value={ratingValue || 5}
                                                                        onChange={(e) => { updateSlider(e.target.value); handleInput("overall_rating", e.target.value, false) }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </label>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }

                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 4 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Your confidence in application & visa process with YES Germany:</label>
                                                            <select name="service_rating" className="service_rating" defaultValue={formData.service_rating || ""} onChange={(e) => { handleInput("service_rating", e.target.value, false) }} required>
                                                                <option value="" disabled defaultChecked>-- Select an option --</option>
                                                                {["Very Confident", "Somewhat Confident", "Neutral", "Not Very Confident", "Not Confident at all"].map((option) => (
                                                                    <option key={option}>{option}</option>
                                                                ))}
                                                            </select>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 5 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">What did you like most about YES Germany?</label>
                                                            <textarea name="most_liked_things" className="most_liked_things" defaultValue={formData["most_liked_things"]} onChange={(e) => { handleInput("most_liked_things", e.target.value, false) }} placeholder="Your suggestions..." />
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 6 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Any suggestions for improvements</label>
                                                            <textarea name="improvements" className="improvements" defaultValue={formData["improvements"]} onChange={(e) => { handleInput("improvements", e.target.value, false) }} placeholder="Your suggestions..." />
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 7 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Would you recommend YES GERMANY to others?</label>
                                                            <select name="recommend" className="recommend" defaultValue={formData.recommend || ""} onChange={(e) => { handleInput("recommend", e.target.value, false) }} required>
                                                                <option value="" disabled defaultChecked>-- Select an option --</option>
                                                                {["Yes", "Maybe", "No"].map((option) => (
                                                                    <option key={option}>{option}</option>
                                                                ))}
                                                            </select>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        currentStep === 8 &&
                                                        <motion.div
                                                            initial={{ opacity: 0 }}
                                                            animate={{ opacity: 1 }}
                                                            exit={{ opacity: 0 }}
                                                            transition={{ durataion: 0.3, delay: 0 }}
                                                            className="w-100">
                                                            <label className="questionHeader">Would you share a testimonial or video review?</label>
                                                            <select name="video-and-testomonials" className="video-and-testomonials" defaultValue={formData["video-and-testomonials"] || ""} onChange={(e) => { handleInput("video-and-testomonials", e.target.value, false) }} required>
                                                                <option value="" disabled defaultChecked>-- Select an option --</option>
                                                                {["Yes", "Maybe", "No"].map((option) => (
                                                                    <option key={option}>{option}</option>
                                                                ))}
                                                            </select>
                                                            {
                                                                message &&
                                                                <div className="alert alert-warning m-0 text-center py-2 mt-3">
                                                                    {message}
                                                                </div>
                                                            }
                                                        </motion.div>
                                                    }
                                                </>
                                            </div>

                                            <div className="button-group">
                                                {currentStep > 0 && (
                                                    <button type="button" className="back-btn" onClick={handleBack}>
                                                        Back
                                                    </button>
                                                )}
                                                {
                                                    currentStep === stepsLength - 1 ? (
                                                        <button type="button" onClick={handleSubmit} className="next-btn">Submit</button>
                                                    )
                                                        :
                                                        (
                                                            <button type="button" className="next-btn" onClick={handleNext}>
                                                                Next
                                                            </button>
                                                        )}
                                            </div>
                                        </form>
                                        :
                                        <div className="thank-you-message">
                                            <h2>Thank You!</h2>
                                            <p>Your response has been recorded.<br />We appreciate your valuable feedback!</p>
                                        </div>
                                }


                            </motion.div>
                            :
                            <div className="feedbackForm">

                                <div className="thank-you-message">
                                    <h2>Thank You!</h2>
                                    <p>Your response has been recorded.<br />We appreciate your valuable feedback!</p>
                                </div>
                            </div>
                }
            </AnimatePresence>
        </div >
    );
}

export default HappyFeedback